// Modules
import { formatDate } from "@jeffcarbine/premmio/public/modules/formatDate/formatDate.js";
import { getMaps } from "./maps.js";
import { addEventDelegate } from "@jeffcarbine/premmio/public/modules/eventDelegate/eventDelegate.js";

// Local Components
import { Btn } from "@jeffcarbine/premmio/public/components/btn/btn.html.js";

// Elements
import { Figure, Figcaption, Strong, Span, LazyImg } from "materiajs/elements";
import { ResponsiveImg } from "@jeffcarbine/premmio/public/components/responsiveImg/responsiveImg.html.js";

// rotate the map backgrounds
const changeMapBackground = () => {
  const mapCategories = document.querySelector("#map-previews"),
    currentBackground = parseInt(mapCategories.getAttribute("data-active"));

  // if less than 5, increment, otherwise reset to 1
  if (currentBackground < 5) {
    mapCategories.setAttribute("data-active", currentBackground + 1);
  } else {
    mapCategories.setAttribute("data-active", 1);
  }
};

setInterval(() => {
  changeMapBackground();
}, 4000);

// category variable is set in the template before this script tag

let mapList;

const mapBoxTemplate = (map) => {
  const publishDate = new Date(map.published);

  return {
    class: "mapCard",
    child: new Figure({
      children: [
        new ResponsiveImg({
          ...map.image,
        }),
        new Figcaption([
          new Strong(map.title),
          new Span(formatDate(publishDate)),
        ]),
        new Btn({
          class: "accent",
          href: `https://patreon.com/posts/${map.patreon_post_id}`,
          target: "_blank",
          textContent: "Get This Map!",
        }),
      ],
    }),
  };
};

getMaps(category, 150, (maps) => {
  // set the global mapList variable
  mapList = maps;

  for (let i = 0; i < 9; i++) {
    const map = maps[i];

    const newestMaps = document.querySelector("#newestMaps"),
      allMaps = document.querySelector("#allMaps");

    // the first three get featured in the newestMaps area
    if (i < 3) {
      Materia.render(mapBoxTemplate(map), (mapBox) => {
        newestMaps.appendChild(mapBox);
      });
    } else {
      allMaps.dataset.index = 8;
      Materia.render(mapBoxTemplate(map), (mapBox) => {
        allMaps.appendChild(mapBox);
      });
    }
  }
});

let loadingMaps = false;

const loadMoreMaps = (button) => {
  if (!loadingMaps) {
    loadingMaps = true;
    button.classList.add("loading");

    setTimeout(() => {
      const allMaps = document.querySelector("#allMaps"),
        index = parseInt(allMaps.dataset.index);

      // load three more maps
      for (let i = index + 1; i < index + 7; i++) {
        const map = mapList[i];

        Materia.render(mapBoxTemplate(map), (mapBox) => {
          allMaps.appendChild(mapBox);
        });
      }

      button.classList.remove("loading");

      setTimeout(() => {
        //update the index, or hide the button if the index almost has been met
        if (index + 9 < mapList.length) {
          allMaps.dataset.index = index + 4;
          loadingMaps = false;
        } else {
          button.style.display = "none";
        }
      }, 1000);
    }, 1000);
  }
};

addEventDelegate("click", "#loadMoreMaps", loadMoreMaps);
